import { connect } from 'react-redux';
import { compose } from 'recompose';

import TimesheetOverview from '../components/TimesheetOverview';
import { queryUserWeeklyTimesheetGQL } from '../graphql/index';

const mapStateToProps = (state) => {
  return {
    userId: state.timesheetApprovals.currentTimesheetForUserId,
    originDate: state.timesheetApprovals.currentTimesheetDate,
  };
};

const mapDispatchToProps = {
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);


// ORDER MATTERS. If you want redux to put the props in required for queries
// you better withRedux FIRST
const enhance = compose(
  withRedux,
  queryUserWeeklyTimesheetGQL,
);

export default enhance(TimesheetOverview);
